<template>
  <div>
    <delegation-rate-menu></delegation-rate-menu>
    <h2>
      {{ $t("settings.delegationRate.standardDelegationRateVehicle.title") }}
    </h2>
    <v-form lazy-validation ref="form" v-model="formValid">
      <text-field-with-copy-default-button
        :button-tooltip="$t('settings.delegationRate.standardDelegationRateVehicle.revertRate')"
        :default-button="true"
        :default-value="delegationRateVehicle.defaults().delegation_vehicle_under_900_rate"
        :label="$t('settings.delegationRate.standardDelegationRateVehicle.vehicleUnder900') + '*'"
        :model.sync="delegationRateVehicle.delegation_vehicle_under_900_rate"
        :rules="delegationRateVehicle.rules().delegation_vehicle_under_900_rate"
        suffix="PLN"
        type="number"
      >
      </text-field-with-copy-default-button>

      <text-field-with-copy-default-button
        :button-tooltip="$t('settings.delegationRate.standardDelegationRateVehicle.revertRate')"
        :default-button="true"
        :default-value="delegationRateVehicle.defaults().delegation_vehicle_above_900_rate"
        :label="$t('settings.delegationRate.standardDelegationRateVehicle.vehicleAbove900') + '*'"
        :model.sync="delegationRateVehicle.delegation_vehicle_above_900_rate"
        :rules="delegationRateVehicle.rules().delegation_vehicle_above_900_rate"
        suffix="PLN"
        type="number"
      >
      </text-field-with-copy-default-button>

      <text-field-with-copy-default-button
        :button-tooltip="$t('settings.delegationRate.standardDelegationRateVehicle.revertRate')"
        :default-button="true"
        :default-value="delegationRateVehicle.defaults().delegation_vehicle_moped_rate"
        :label="$t('settings.delegationRate.standardDelegationRateVehicle.moped') + '*'"
        :model.sync="delegationRateVehicle.delegation_vehicle_moped_rate"
        :rules="delegationRateVehicle.rules().delegation_vehicle_moped_rate"
        suffix="PLN"
        type="number"
      >
      </text-field-with-copy-default-button>

      <text-field-with-copy-default-button
        :button-tooltip="$t('settings.delegationRate.standardDelegationRateVehicle.revertRate')"
        :default-button="true"
        :default-value="delegationRateVehicle.defaults().delegation_vehicle_motorcycle_rate"
        :label="$t('settings.delegationRate.standardDelegationRateVehicle.motorcycle') + '*'"
        :model.sync="delegationRateVehicle.delegation_vehicle_motorcycle_rate"
        :rules="delegationRateVehicle.rules().delegation_vehicle_motorcycle_rate"
        suffix="PLN"
        type="number"
      >
      </text-field-with-copy-default-button>
    </v-form>
    <div>
      <v-btn :disabled="!formValid" @click="save()" block color="accent">{{ $t("global.save") }}</v-btn>
    </div>
  </div>
</template>

<script>
import DelegationRateMenu from "../../../components/Settings/DelegationRate/DelegationRateMenu.vue";
import TextFieldWithCopyDefaultButton from "../../../components/CustomInputComponents/TextFieldWithCopyDefaultButton.vue";
import DefaultDelegationRateVehicle from "../../../models/settings/delegationRateVehicle";

export default {
  name: "StandardDelegationRateVehicle",
  components: { TextFieldWithCopyDefaultButton, DelegationRateMenu },
  data: () => ({
    formValid: true,
    delegationRateVehicle: new DefaultDelegationRateVehicle()
  }),
  methods: {
    save() {
      this.delegationRateVehicle.save().then(() => {
        this.$store.dispatch("snackbarPush", {
          text: this.$t("global.saved"),
          position: "down"
        });
      });
    }
  },
  created() {
    this.delegationRateVehicle.load();
  }
};
</script>

<style scoped></style>
